import React from 'react';
import { OidcProvider, loadUser } from 'redux-oidc';
import { useSelector } from 'react-redux';
import useUserManager from '@ers/authorization/userManager';
import { UrlHelper } from '@ers/helpers/';
import { SentryLogger as Sentry } from '@ers/errors';
import AuthState from './AuthorizationState';
import store from '../App.store';
import { useAuthStateContext } from './Authorization';

const useCurrentAuthStateTransform = (userManager) => {
    const stateTransformers = {};
    const { isLoadingUser, user, oidcSilentRenewError } = useSelector((state) => { return { ...state.oidc, oidcSilentRenewError: state.app.oidcSilentRenewError } });
    const signinRedirect = () => {
        const urlHelper = new UrlHelper();
        const redirectParams = {
            data: urlHelper.hash.getUrlWithTrimmed(['accessCode', 'magicLinkMailId']),
            extraQueryParams: urlHelper.hash.get(),
            prompt: 'login'
        };
        try {
            sessionStorage.setItem('SR', new Date());
        } catch (error) {
            Sentry.error(error);
        }
        userManager.signinRedirect(redirectParams);
    };
    const { authState, setAuthState } = useAuthStateContext();

    stateTransformers[AuthState.NotLoaded] = () => {
        loadUser(store, userManager);
        return AuthState.Loading;
    };

    stateTransformers[AuthState.Loading] = () => {
        let state = AuthState.Loading;
        if (!isLoadingUser) {
            if (user === null) {
                state = AuthState.NotSignedIn;
            } else {
                state = AuthState.SignedIn;
            }
        }
        return state;
    };

    stateTransformers[AuthState.NotSignedIn] = () => {
        signinRedirect();
        return AuthState.SigningIn;
    };

    stateTransformers[AuthState.SigningIn] = () => AuthState.SigningIn;

    stateTransformers[AuthState.SignedIn] = () => {
        let state = AuthState.SignedIn;
        if (oidcSilentRenewError) {
            signinRedirect();
            state = AuthState.SigningIn;
        }
        if (user === null) {
            state = AuthState.SignedOut;
        }
        return state;
    };
    stateTransformers[AuthState.SignedOut] = () => {
        if (oidcSilentRenewError) {
            signinRedirect();
            return AuthState.SigningIn;
        }
        return AuthState.SignedOut;
    };
    const newAuthState = stateTransformers[authState]();
    if (newAuthState !== authState) {
        setAuthState(newAuthState);
    }
};

const OidcComponent = (props) => {
    const userManager = useUserManager();
    userManager.clearStaleState();
    useCurrentAuthStateTransform(userManager);
    const { children } = props;
    return (
        <OidcProvider store={store} userManager={userManager}>
            {children}
        </OidcProvider>
    );
};
export default OidcComponent;